import { render, staticRenderFns } from "./LandlordKYCForm.vue?vue&type=template&id=c9d288e0&"
import script from "./LandlordKYCForm.vue?vue&type=script&lang=js&"
export * from "./LandlordKYCForm.vue?vue&type=script&lang=js&"
import style0 from "./LandlordKYCForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LandlordKYCForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports